import { subscribe as le } from "@seamless/one-context";
import { ref as p, computed as m, toValue as g, watch as I, useSSRContext as Fe, onMounted as B, onBeforeUnmount as Le, onErrorCaptured as qe, getCurrentInstance as Re, onUnmounted as Qe, getCurrentScope as We, onScopeDispose as Ye, shallowRef as de, onBeforeMount as Ze } from "vue";
import { initializeLogger as ke } from "@seamless/logger";
import { initializeStore as fe, SeamlessConnection as Oe } from "@seamless/store";
import { getTranslation as q } from "@owc/aem-translations-util";
import { MediaQueryService as De } from "@workbench/core";
import { u as Yn } from "./useUuid-BGpRkYny.js";
var _ = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "Mercedes-Benz", e.MERCEDES_AMG = "Mercedes-AMG", e.MERCEDES_MAYBACH = "Mercedes-Maybach", e))(_ || {}), T = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "MERCEDES_BENZ", e.MERCEDES_AMG = "MERCEDES_AMG", e.MERCEDES_MAYBACH = "MERCEDES_MAYBACH", e.MERCEDESBENZ = "Mercedes-Benz", e.MERCEDESAMG = "Mercedes-AMG", e.MERCEDESMAYBACH = "Mercedes-Maybach", e))(T || {}), ie = /* @__PURE__ */ ((e) => (e.AMG = "amg", e.MAYBACH = "maybach", e))(ie || {}), Q;
// @__NO_SIDE_EFFECTS__
function Ke(e) {
  return {
    lang: e?.lang ?? Q?.lang,
    message: e?.message,
    abortEarly: e?.abortEarly ?? Q?.abortEarly,
    abortPipeEarly: e?.abortPipeEarly ?? Q?.abortPipeEarly
  };
}
var Je;
// @__NO_SIDE_EFFECTS__
function Xe(e) {
  return Je?.get(e);
}
var et;
// @__NO_SIDE_EFFECTS__
function tt(e) {
  return et?.get(e);
}
var nt;
// @__NO_SIDE_EFFECTS__
function rt(e, n) {
  return nt?.get(e)?.get(n);
}
// @__NO_SIDE_EFFECTS__
function Ne(e) {
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : n;
}
function A(e, n, t, r, o) {
  const c = o && "input" in o ? o.input : t.value, a = o?.expected ?? e.expects ?? null, s = o?.received ?? /* @__PURE__ */ Ne(c), i = {
    kind: e.kind,
    type: e.type,
    input: c,
    expected: a,
    received: s,
    message: `Invalid ${n}: ${a ? `Expected ${a} but r` : "R"}eceived ${s}`,
    requirement: e.requirement,
    path: o?.path,
    issues: o?.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, u = e.kind === "schema", l = o?.message ?? e.message ?? /* @__PURE__ */ rt(e.reference, i.lang) ?? (u ? /* @__PURE__ */ tt(i.lang) : null) ?? r.message ?? /* @__PURE__ */ Xe(i.lang);
  l !== void 0 && (i.message = typeof l == "function" ? (
    // @ts-expect-error
    l(i)
  ) : l), u && (t.typed = !1), t.issues ? t.issues.push(i) : t.issues = [i];
}
// @__NO_SIDE_EFFECTS__
function L(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(n) {
      return e["~run"]({ value: n }, /* @__PURE__ */ Ke());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function at(e, n) {
  const t = [...new Set(e)];
  return t.length > 1 ? `(${t.join(` ${n} `)})` : t[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function z(e, n) {
  return {
    kind: "validation",
    type: "max_length",
    reference: z,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: n,
    "~run"(t, r) {
      return t.typed && t.value.length > this.requirement && A(this, "length", t, r, {
        received: `${t.value.length}`
      }), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function U(e, n) {
  return {
    kind: "validation",
    type: "min_length",
    reference: U,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: n,
    "~run"(t, r) {
      return t.typed && t.value.length < this.requirement && A(this, "length", t, r, {
        received: `${t.value.length}`
      }), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function pe(e, n) {
  return {
    kind: "validation",
    type: "regex",
    reference: pe,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: n,
    "~run"(t, r) {
      return t.typed && !this.requirement.test(t.value) && A(this, "format", t, r), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ie(e, n, t) {
  return typeof e.fallback == "function" ? (
    // @ts-expect-error
    e.fallback(n, t)
  ) : (
    // @ts-expect-error
    e.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function ot(e, n) {
  return {
    ...e,
    fallback: n,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, r) {
      const o = e["~run"](t, r);
      return o.issues ? { typed: !0, value: /* @__PURE__ */ Ie(this, o, r) } : o;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Be(e, n, t) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(n, t)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function me(e, n) {
  return {
    kind: "schema",
    type: "array",
    reference: me,
    expects: "Array",
    async: !1,
    item: e,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, r) {
      const o = t.value;
      if (Array.isArray(o)) {
        t.typed = !0, t.value = [];
        for (let c = 0; c < o.length; c++) {
          const a = o[c], s = this.item["~run"]({ value: a }, r);
          if (s.issues) {
            const i = {
              type: "array",
              origin: "value",
              input: o,
              key: c,
              value: a
            };
            for (const u of s.issues)
              u.path ? u.path.unshift(i) : u.path = [i], t.issues?.push(u);
            if (t.issues || (t.issues = s.issues), r.abortEarly) {
              t.typed = !1;
              break;
            }
          }
          s.typed || (t.typed = !1), t.value.push(s.value);
        }
      } else
        A(this, "type", t, r);
      return t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function D(e, n) {
  return {
    kind: "schema",
    type: "literal",
    reference: D,
    expects: /* @__PURE__ */ Ne(e),
    async: !1,
    literal: e,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, r) {
      return t.value === this.literal ? t.typed = !0 : A(this, "type", t, r), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Pe(e, n) {
  return {
    kind: "schema",
    type: "nullish",
    reference: Pe,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    default: n,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, r) {
      return (t.value === null || t.value === void 0) && (this.default !== void 0 && (t.value = /* @__PURE__ */ Be(this, t, r)), t.value === null || t.value === void 0) ? (t.typed = !0, t) : this.wrapped["~run"](t, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function H(e, n) {
  return {
    kind: "schema",
    type: "object",
    reference: H,
    expects: "Object",
    async: !1,
    entries: e,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, r) {
      const o = t.value;
      if (o && typeof o == "object") {
        t.typed = !0, t.value = {};
        for (const c in this.entries) {
          const a = this.entries[c];
          if (c in o || (a.type === "exact_optional" || a.type === "optional" || a.type === "nullish") && // @ts-expect-error
          a.default !== void 0) {
            const s = c in o ? (
              // @ts-expect-error
              o[c]
            ) : /* @__PURE__ */ Be(a), i = a["~run"]({ value: s }, r);
            if (i.issues) {
              const u = {
                type: "object",
                origin: "value",
                input: o,
                key: c,
                value: s
              };
              for (const l of i.issues)
                l.path ? l.path.unshift(u) : l.path = [u], t.issues?.push(l);
              if (t.issues || (t.issues = i.issues), r.abortEarly) {
                t.typed = !1;
                break;
              }
            }
            i.typed || (t.typed = !1), t.value[c] = i.value;
          } else if (a.fallback !== void 0)
            t.value[c] = /* @__PURE__ */ Ie(a);
          else if (a.type !== "exact_optional" && a.type !== "optional" && a.type !== "nullish" && (A(this, "key", t, r, {
            input: void 0,
            expected: `"${c}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: o,
                key: c,
                // @ts-expect-error
                value: o[c]
              }
            ]
          }), r.abortEarly))
            break;
        }
      } else
        A(this, "type", t, r);
      return t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function F(e) {
  return {
    kind: "schema",
    type: "string",
    reference: F,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, t) {
      return typeof n.value == "string" ? n.typed = !0 : A(this, "type", n, t), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ve(e) {
  let n;
  if (e)
    for (const t of e)
      n ? n.push(...t.issues) : n = t.issues;
  return n;
}
// @__NO_SIDE_EFFECTS__
function $e(e, n) {
  return {
    kind: "schema",
    type: "union",
    reference: $e,
    expects: /* @__PURE__ */ at(
      e.map((t) => t.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, r) {
      let o, c, a;
      for (const s of this.options) {
        const i = s["~run"]({ value: t.value }, r);
        if (i.typed)
          if (i.issues)
            c ? c.push(i) : c = [i];
          else {
            o = i;
            break;
          }
        else
          a ? a.push(i) : a = [i];
      }
      if (o)
        return o;
      if (c) {
        if (c.length === 1)
          return c[0];
        A(this, "type", t, r, {
          issues: /* @__PURE__ */ ve(c)
        }), t.typed = !0;
      } else {
        if (a?.length === 1)
          return a[0];
        A(this, "type", t, r, {
          issues: /* @__PURE__ */ ve(a)
        });
      }
      return t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ee(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, t) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (n.issues && (r.kind === "schema" || r.kind === "transformation")) {
            n.typed = !1;
            break;
          }
          (!n.issues || !t.abortEarly && !t.abortPipeEarly) && (n = r["~run"](n, t));
        }
      return n;
    }
  };
}
const Ge = /^[a-zA-Z]{2}$/, it = /* @__PURE__ */ Ee(
  /* @__PURE__ */ F(),
  /* @__PURE__ */ U(2),
  /* @__PURE__ */ z(2),
  /* @__PURE__ */ pe(Ge, "Must match two-letter pattern")
), st = /* @__PURE__ */ Ee(
  /* @__PURE__ */ F(),
  /* @__PURE__ */ U(2),
  /* @__PURE__ */ z(2),
  /* @__PURE__ */ pe(Ge, "Must match two-letter pattern")
), ct = /* @__PURE__ */ Pe(/* @__PURE__ */ Ee(/* @__PURE__ */ F(), /* @__PURE__ */ U(3), /* @__PURE__ */ z(5))), xe = /* @__PURE__ */ ot(
  /* @__PURE__ */ $e([
    /* @__PURE__ */ D("MERCEDES_BENZ"),
    /* @__PURE__ */ D("MERCEDES_AMG"),
    /* @__PURE__ */ D("MERCEDES_MAYBACH"),
    /* @__PURE__ */ D("Mercedes-Benz"),
    /* @__PURE__ */ D("Mercedes-AMG"),
    /* @__PURE__ */ D("Mercedes-Maybach")
  ]),
  "Mercedes-Benz"
), ut = /* @__PURE__ */ H({
  lang: it,
  market: st,
  stage: ct,
  brand: /* @__PURE__ */ me(xe)
});
({
  ...ut.entries,
  ...(/* @__PURE__ */ H({ brand: /* @__PURE__ */ me(xe) })).entries
});
function lt(e) {
  switch (e) {
    case _.MERCEDES_AMG:
    case T.MERCEDES_AMG:
    case T.MERCEDESAMG:
    case ie.AMG:
      return _.MERCEDES_AMG;
    case _.MERCEDES_MAYBACH:
    case T.MERCEDES_MAYBACH:
    case T.MERCEDESMAYBACH:
    case ie.MAYBACH:
      return _.MERCEDES_MAYBACH;
    default:
      return _.MERCEDES_BENZ;
  }
}
function yn(e) {
  const n = p(null), t = p(null), r = m(() => {
    const c = g(e) ?? n.value ?? t.value;
    return lt(c);
  });
  le("PageConnection", {
    tenant: "sccs",
    componentName: "sccs-one-teaser",
    callback: (c) => {
      t.value = c.pageEnvironmentVariables.vehicleData?.subBrands[0], n.value = c.pageEnvironmentVariables.brand?.subBrand;
    }
  });
  const o = m(() => {
    switch (r?.value) {
      case _.MERCEDES_AMG:
        return T.MERCEDESAMG;
      case _.MERCEDES_MAYBACH:
        return T.MERCEDESMAYBACH;
      default:
        return T.MERCEDESBENZ;
    }
  });
  return { subBrand: r, brandUrlParameter: o };
}
function dt(e) {
  switch (e?.toLowerCase()?.trim() ?? "prod") {
    case "dev":
    case "development":
    case "local":
    case "localhost":
      return "TEST";
    case "int":
    case "integration":
    case "test":
    case "testing":
      return "INT";
    case "pprod":
    case "preprod":
    case "pre-production":
    case "preproduction":
      return "PPROD";
    case "prod":
    case "production":
      return "PROD";
    default:
      return "LOCAL";
  }
}
function ft(e) {
  return e.toLowerCase().trim();
}
const Cn = "fe-vehicle-tiles", W = "fe-one-teaser-platform", pt = {
  LOCAL: "https://assets.oneweb.mercedes-benz.com",
  TEST: "https://dev.assets.oneweb.mercedes-benz.com",
  INT: "https://int.assets.oneweb.mercedes-benz.com",
  PPROD: "https://preprod.assets.oneweb.mercedes-benz.com",
  PROD: "https://assets.oneweb.mercedes-benz.com"
};
function mt(e, n, t) {
  const r = pt[dt(e) ?? "PROD"], o = ft(n);
  return `${r}/config/emh/${t}/${o}/config.json`;
}
const h = ke("DH_IO_SCSS/CONFIG_SERVICE_OT");
async function Et(e) {
  const n = new Request(e);
  try {
    return await fetch(n);
  } catch (t) {
    return h.warn("Error fetching config from network", t), Response.error();
  }
}
let Y = null;
function hn(e) {
  const n = p(null), t = p(!0), r = p(null), o = new URLSearchParams(window.location.search), c = (E, v, b, R) => {
    const k = W + "_" + E + "_" + v, O = o.get(k), N = O ? ["t", "true"].includes(O.toLocaleLowerCase()) : void 0, f = N ?? b ?? R;
    return h.log(W + "_" + E + "_" + v + " set to " + f, {
      urlParamResult: N,
      configServiceResult: b,
      fallback: R
    }), f;
  }, a = m(() => !t.value), s = m(
    () => c("focMarket", "isFocMarket", n.value?.focMarket?.isFocMarket, !1)
  ), i = m(
    () => c(
      "personalization",
      "personalizationEnabled",
      n.value?.personalization?.personalizationEnabled,
      !1
    )
  ), u = m(
    () => c(
      "switchToOneTeaser",
      "enableOneTeaserHome",
      n.value?.switchToOneTeaser?.enableOneTeaserHome,
      !0
    )
  ), l = m(
    () => c(
      "switchToOneTeaser",
      "enableOneTeaserCampaign",
      n.value?.switchToOneTeaser?.enableOneTeaserCampaign,
      !0
    )
  ), d = m(
    () => c("config", "failOnMissingPrice", n.value?.config?.failOnMissingPrice, !0)
  ), S = m(
    () => c("config", "useCurrentEnv", n.value?.config?.useCurrentEnv, !0)
  );
  async function C() {
    t.value = !0, r.value = null, w().then((E) => {
      if (E) {
        if (E.error)
          throw h.warn("fetching configs failed", E.error), E.error;
        n.value = E.body, t.value = !1, h.log("configs set", n.value, e.stage, e.country);
      }
    });
  }
  async function w() {
    return n.value ? (h.log("configs already loaded"), { body: n.value, error: null }) : (Y ? h.log("configs already loaded by another component, using that response") : (h.log("fetching configs"), Y = new Promise((E) => {
      (async () => {
        try {
          const v = g(e.stage), b = g(e.country);
          if (!v || !b) {
            E(null), h.log("stage or country missing", v, b);
            return;
          }
          const R = mt(v, b, W), k = await Et(R);
          if (!k?.ok) {
            E({
              body: null,
              error: new Error(`HTTP error, failed to load config! status: ${k?.status}`)
            });
            return;
          }
          const O = await k.json();
          h.log("configs fetched", O), E({ body: O, error: null });
        } catch (v) {
          h.warn("unknown error occured", v), E({ body: null, error: new Error("Unknown error occurred") });
        }
      })();
    })), Y);
  }
  return I(
    [e.stage, e.country],
    ([E, v]) => {
      !E || !v || C();
    },
    {
      immediate: !0
    }
  ), {
    isFeatureToggleLoaded: a,
    isFocMarket: s,
    isPersonalizationEnabled: i,
    isOneTeaserHomeEnabled: u,
    isOneTeaserCampaignEnabled: l,
    isFailOnMissingPriceEnabled: d,
    isUseCurrentEnvEnabled: S
  };
}
/*! aem-component-data-util 1.2.0 */
function gt(e) {
  if (!(typeof window < "u")) {
    let o = Fe()?.AEMContext;
    return { payload: o?.payload, config: o?.config };
  }
  let t = window.top || window, r = t.__GLOBAL_CONTEXT__?.get()?.componentData ?? t.aemNamespace?.componentData;
  return e ? Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, r[o]])) : r[e] : r;
}
const An = (e, n = {
  reactive: !0
}) => {
  const t = p([]), r = p(null);
  function o(c) {
    const a = c.querySelector("[data-slot-outlet]");
    if (!a || !a.children.length) return;
    const s = a.children[0].localName === "slot" ? a.children[0].assignedElements() : a.children, i = Array.from(s || []).map(
      (u) => u?.getAttribute("component-id")
    );
    t.value = [];
    for (const u of i) {
      if (!u) continue;
      const l = { payload: gt(u).payload, componentId: u };
      t.value.push(l);
    }
  }
  return B(() => {
    const c = g(e);
    if (!c || (o(c), !n.reactive)) return;
    r.value?.disconnect();
    const a = { childList: !0, subtree: !0 }, s = (u) => {
      u.some((d) => d.type === "childList") && o(c);
    };
    r.value = new MutationObserver(s);
    const i = c?.querySelector("[data-slot-outlet]");
    i && r.value.observe(i, a);
  }), { childElementConfigs: t, syncConfigs: o };
}, Z = {
  separator: "-",
  id: "35e68f8b5769ffbe51d5e3e245f7498f"
}, K = {
  separator: "-",
  id: "256327257efa0b223e1fa85ba6b0cbf7"
}, J = {
  separator: "_",
  id: "42b5f1b854ae37cc8b351c232bf6cb79"
}, vt = "SCCS_MBTI-DISCO-AIR", wn = ["Mercedes-AMG", "MERCEDES_AMG"], Mn = Symbol.for("componentId"), _n = "Mercedes-Benz";
function Tn(e, n, t = fe()) {
  const r = p();
  let o;
  const { unsubscribe: c } = t.subscribe(vt, (i) => {
    o = i, s(g(e), g(n));
  });
  function a(i) {
    return r.value?.tileData && r.value?.state === "SUCCESS" && r.value?.inflateId === i;
  }
  function s(i, u) {
    if (i) {
      if (u) {
        r.value = {
          tileData: { ...u, state: "SUCCESS" },
          state: "SUCCESS",
          inflateId: i
        };
        return;
      }
      if (!a(i)) {
        if (!o || i && !o?.tileData?.[i])
          r.value = {
            // waiting for connection
            state: "PENDING",
            inflateId: i ?? "no-inflate-id-could-be-determined"
          };
        else if (i) {
          const l = o?.tileData?.[i], d = l?.state;
          r.value = {
            tileData: l,
            state: d,
            inflateId: i
          };
        }
      }
    }
  }
  return I(
    [() => g(e), () => g(n)],
    ([i, u]) => {
      s(i, u);
    },
    { immediate: !0 }
  ), { tileDataBundle: r, unsubscribe: c };
}
async function bt(e) {
  return new Promise((n) => {
    le("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (t) => {
        n(`${t.pageEnvironmentVariables.language}${e}${t.pageEnvironmentVariables.country}`);
      }
    });
  });
}
async function St() {
  return new Promise((e) => {
    le("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (n) => {
        e(n.pageEnvironmentVariables.country);
      }
    });
  });
}
const yt = async (e) => await bt(e), Ln = async () => await St(), X = ke("DH_IO_SCSS/I18N");
let ee = null;
const G = p({}), x = p({}), te = p({});
function Rn() {
  const e = async (a) => {
    let s = await yt(a);
    return s === `de${a}AQ` && (s = `de${a}DE`), s === `en${a}AQ` && (s = `en${a}AU`), s;
  };
  async function n() {
    return ee ? X.log("translations already loaded by another component, using that response") : (X.log("fetching translations"), ee = new Promise((a) => {
      (async () => {
        try {
          G.value = await q(
            await e(J.separator),
            J.id,
            "i18next"
          );
        } catch (s) {
          console.warn(
            `CMN_I18N_CMP: Failed to fetch compare translations for market ${await e(J.separator)}`,
            { cause: s }
          );
        }
        try {
          x.value = await q(
            await e(Z.separator),
            Z.id,
            "i18next"
          );
        } catch (s) {
          console.warn(
            `CMN_I18N_DCP: Failed to fetch DCP translations for market ${await e(Z.separator)}`,
            { cause: s }
          );
        }
        try {
          te.value = await q(
            await e(K.separator),
            K.id,
            "i18next"
          );
        } catch (s) {
          console.warn(
            `CMN_I18N_OT: Failed to fetch OneTeaser translations for market ${await e(K.separator)}`,
            { cause: s }
          );
        }
        X.log("translations loaded", {
          compareTranslations: G.value,
          dcpTranslations: x.value,
          oneTeaserTranslations: te.value
        }), a();
      })();
    })), ee;
  }
  function t(a) {
    return !!o(a, G.value) || !!o(a, x.value);
  }
  function r(a, s) {
    if (!a)
      return "";
    const i = o(a, G.value) || o(a, x.value) || o(a, te.value) || a;
    return c(i, s);
  }
  function o(a, s) {
    const i = a.split(".");
    let u = s;
    for (const l of i) {
      if (u === void 0 || typeof u == "string") return;
      u = u[l];
    }
    if (typeof u == "string")
      return u;
  }
  function c(a, s) {
    if (!s)
      return a;
    let i = a;
    return Object.entries(s).forEach((u) => {
      const [l, d] = u;
      i = i.replace(`{{${l}}}`, d), i = i.replace(`{{ ${l} }}`, d), i = i.replace(`{${l}}`, d), i = i.replace(`{ ${l} }`, d);
    }), i;
  }
  return { loadTranslations: n, t: r, existsWithoutFallback: t };
}
/*! connection-aem-environment 2.8.0 */
const je = "OWC_AEM_ENV", Ct = new class extends Oe {
  constructor() {
    super(je);
  }
  get initialState() {
    const e = window.aemNamespace?.environmentVariables || window.top?.aemNamespace?.environmentVariables, n = window.aemNamespace?.pageEnvironmentVariables || window.top?.aemNamespace?.pageEnvironmentVariables;
    return e && n ? { ...e, ...n } : {};
  }
  getReducer() {
    return () => this.initialState;
  }
  getPublicDispatchers() {
    return {};
  }
}(), ht = async () => {
  const e = fe();
  return await (async () => {
    if (!window.top?.aemNamespace && !window.aemNamespace) return new Promise(((n) => {
      let t;
      Object.defineProperty(window.top, "aemNamespace", { get: () => t, async set(r) {
        t = r, n();
      } });
    }));
  })(), await (async () => {
    if (!window.top?.aemNamespace?.environmentVariables && !window?.aemNamespace?.environmentVariables) return new Promise(((n) => {
      let t;
      Object.defineProperty(window.top?.aemNamespace, "environmentVariables", { get: () => t, set(r) {
        t = r, n();
      } });
    }));
  })(), await (async () => {
    if (!window.top?.aemNamespace?.pageEnvironmentVariables && !window?.aemNamespace?.pageEnvironmentVariables) return new Promise(((n) => {
      let t;
      Object.defineProperty(window.top?.aemNamespace, "pageEnvironmentVariables", { get: () => t, set(r) {
        t = r, n();
      } });
    }));
  })(), e.addConnection(Ct);
};
function At(e, n, t) {
  return !n || !t ? "" : `${n}${e[1]}${t}`;
}
const be = p(""), se = p(""), ce = p(""), Se = p(!1), wt = m(() => At`${ce.value}_${se.value}`);
function kn(e) {
  let n;
  return B(async () => {
    ht(), n = await e.subscribe(
      je,
      (t) => {
        be.value = t.stage, se.value = t.country, ce.value = t.language, Se.value = !0;
      }
    ).unsubscribe;
  }), Le(() => {
    n?.();
  }), {
    environment: be,
    country: se,
    language: ce,
    marketId: wt,
    aemLoaded: Se
  };
}
function On(e) {
  const n = m(() => g(e) === "campaign"), t = m(() => g(e) === "overlapping"), r = m(() => g(e) === "workbench7"), o = m(() => g(e) === "compact"), c = m(() => g(n) || t.value || r.value ? "classic" : "compact"), a = m(() => g(c) === "classic");
  return {
    isAppearanceCampaign: n,
    isAppearanceOverlapping: t,
    isAppearanceWorkbench: r,
    isAppearanceCompact: o,
    cssProject: c,
    useWbClasses: a
  };
}
function ye(e) {
  throw Error(e);
}
var Mt = /* @__PURE__ */ ((e) => (e[e.COMPONENT = 1] = "COMPONENT", e[e.DATALOADING = 2] = "DATALOADING", e[e.IMAGE = 3] = "IMAGE", e[e.PLS = 4] = "PLS", e[e.FCIS = 5] = "FCIS", e))(Mt || {}), _t = /* @__PURE__ */ ((e) => (e.CRITICAL = "CRITICAL", e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW", e))(_t || {});
function Tt({ error: e, severity: n, component: t, message: r }, o) {
  const c = e.cause.message;
  switch (n) {
    case "CRITICAL":
    case "HIGH":
      o?.error("An error has been encountered, please find more information below"), o?.table({
        severity: n,
        category: t,
        message: r,
        cause: c
      });
      break;
    case "MEDIUM":
    case "LOW":
    default:
      o?.log(`Error in component ${t} with severity ${n}: ${r}`, e);
      break;
  }
}
const Dn = (e) => {
  const n = p(/* @__PURE__ */ new Map());
  qe((a, s, i) => {
    const u = s, l = u._.type.__name === "ErrorBoundary" ? Re() ?? ye("could not find vue instance") : u._, d = l.exposed?.severity ?? "CRITICAL", S = l.exposed?.category ?? 1, C = { error: a, severity: d, component: S, message: a.message };
    if (t(l, C), Tt(C, e.logger), e.onErrorCallback?.(), !e.allowPropagation) return !1;
  }), B(() => {
    r();
  }), Qe(() => {
    r();
  });
  function t(a, { error: s, severity: i, component: u }) {
    const l = a.type.name ?? a.type.__name ?? ye("a component catching errors must have a name");
    if (n.value.has(l)) {
      const d = n.value.get(l);
      if (!d) return;
      n.value.set(l, [
        ...d,
        { error: s, severity: i, component: u, message: s?.message ?? "" }
      ]);
    } else
      n.value.set(l, [
        { error: s, severity: i, component: u, message: s?.message ?? "" }
      ]);
  }
  function r() {
    n.value.clear();
  }
  const o = m(() => !!n.value.size), c = m(() => Array.from(n.value.values()).reduce((a, s) => a + s.length, 0));
  return { componentsWithErrors: n, hasErrors: o, errorCount: c };
};
function Nn(e = window) {
  return {
    currentStaticMediaQuery: new De(e).getCurrentMediaQuery()
  };
}
function In(e, n, t, r) {
  const o = (a) => {
    t(), a?.disconnect(), r?.logger?.debug(`fired load event for ${e} and query ${n}`);
  };
  function c(a) {
    if (a.shadowRoot) {
      const s = (u, l) => {
        if (!a.shadowRoot) throw new Error("element does not have a shadowRoot");
        const d = a.shadowRoot.querySelector(n);
        d && "complete" in d && d.complete ? o(l) : d && d.addEventListener("load", () => {
          o(l);
        });
      };
      new MutationObserver(s).observe(a.shadowRoot, { subtree: !0, childList: !0 });
    }
  }
  I(
    e,
    (a) => {
      a && customElements.whenDefined(a.localName).then(() => c(g(a)));
    },
    { immediate: !0 }
  );
}
/*! connection-aem-tracking 2.8.0 */
const He = "OWC_TRACKING_MANAGER", Ce = "PUSH_TRACKING_EVENT", he = { trackingEvents: [] };
new class extends Oe {
  constructor() {
    super(He);
  }
  get initialState() {
    return he;
  }
  getReducer() {
    return (e = he, n) => n.type === this.getActionType(Ce) ? { ...e, trackingEvents: [...e.trackingEvents, n.payload] } : e;
  }
  getPublicDispatchers() {
    return { pushTrackingEvent: (e) => (window.top?.dataLayer_ow.push(e), this.getAction(Ce, e)) };
  }
}();
const Lt = () => fe().getConnectionDispatchers(He).then(((e) => e));
function Rt(e) {
  return We() ? (Ye(e), !0) : !1;
}
const kt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Ot = (e) => e != null, ne = () => {
};
function Dt(e) {
  return Array.isArray(e) ? e : [e];
}
function Nt(e, n, t) {
  return I(
    e,
    n,
    {
      ...t,
      once: !0
    }
  );
}
const Ve = kt ? window : void 0;
function re(e) {
  var n;
  const t = g(e);
  return (n = t?.$el) != null ? n : t;
}
// @__NO_SIDE_EFFECTS__
function It() {
  const e = de(!1), n = Re();
  return n && B(() => {
    e.value = !0;
  }, n), e;
}
// @__NO_SIDE_EFFECTS__
function Bt(e) {
  const n = /* @__PURE__ */ It();
  return m(() => (n.value, !!e()));
}
function Pt(e, n, t = {}) {
  const {
    root: r,
    rootMargin: o = "0px",
    threshold: c = 0,
    window: a = Ve,
    immediate: s = !0
  } = t, i = /* @__PURE__ */ Bt(() => a && "IntersectionObserver" in a), u = m(() => {
    const w = g(e);
    return Dt(w).map(re).filter(Ot);
  });
  let l = ne;
  const d = de(s), S = i.value ? I(
    () => [u.value, re(r), d.value],
    ([w, E]) => {
      if (l(), !d.value || !w.length)
        return;
      const v = new IntersectionObserver(
        n,
        {
          root: re(E),
          rootMargin: o,
          threshold: c
        }
      );
      w.forEach((b) => b && v.observe(b)), l = () => {
        v.disconnect(), l = ne;
      };
    },
    { immediate: s, flush: "post" }
  ) : ne, C = () => {
    l(), S(), d.value = !1;
  };
  return Rt(C), {
    isSupported: i,
    isActive: d,
    pause() {
      l(), d.value = !1;
    },
    resume() {
      d.value = !0;
    },
    stop: C
  };
}
function $t(e, n = {}) {
  const {
    window: t = Ve,
    scrollTarget: r,
    threshold: o = 0,
    rootMargin: c,
    once: a = !1
  } = n, s = de(!1), { stop: i } = Pt(
    e,
    (u) => {
      let l = s.value, d = 0;
      for (const S of u)
        S.time >= d && (d = S.time, l = S.isIntersecting);
      s.value = l, a && Nt(s, () => {
        i();
      });
    },
    {
      root: r,
      window: t,
      threshold: o,
      rootMargin: g(c)
    }
  );
  return s;
}
var Gt = /* @__PURE__ */ ((e) => (e.CAMPAIGN = "campaign", e.SLEEK = "sleek", e.YOUNGSTARS = "young_stars", e.RICH = "rich", e))(Gt || {});
const Ae = {
  eventName: "view_promotion",
  category: "impression",
  label: void 0
  // no label for impression regarding documentation
}, Bn = {
  eventName: "select_promotion",
  category: "link",
  label: "teaser"
  /* TEASER */
}, Pn = {
  eventName: "select_promotion",
  category: "link"
  /* LINK */
};
function $n(e, n) {
  let t = null;
  Ze(async () => {
    t ||= await Lt();
  });
  function r(c, a) {
    const s = p(!1), i = $t(c), u = I(
      i,
      (l) => {
        l && !s.value && (s.value = !0, a ? o(Ae, a) : o(Ae), u?.());
      },
      { immediate: !0 }
    );
  }
  async function o(c, a) {
    const s = {
      event: "click",
      eventDetail: {
        name: c.eventName,
        category: c.category,
        action: `banner.${e}`,
        label: c.label,
        URL: c.URL ?? void 0,
        promotion: a
      },
      application: {
        id: "seamless_emh",
        version: "",
        subId: "vehicles",
        type: void 0,
        parentApplicationId: "aem",
        businessUnit: n?.value?.toLowerCase() ?? void 0
      }
    };
    typeof requestIdleCallback == "function" ? requestIdleCallback(() => {
      t?.pushTrackingEvent(s);
    }) : t?.pushTrackingEvent(s);
  }
  return {
    track: o,
    trackVisibility: r
  };
}
var xt = typeof global == "object" && global && global.Object === Object && global, jt = typeof self == "object" && self && self.Object === Object && self, ze = xt || jt || Function("return this")(), V = ze.Symbol, Ue = Object.prototype, Ht = Ue.hasOwnProperty, Vt = Ue.toString, $ = V ? V.toStringTag : void 0;
function zt(e) {
  var n = Ht.call(e, $), t = e[$];
  try {
    e[$] = void 0;
    var r = !0;
  } catch {
  }
  var o = Vt.call(e);
  return r && (n ? e[$] = t : delete e[$]), o;
}
var Ut = Object.prototype, Ft = Ut.toString;
function qt(e) {
  return Ft.call(e);
}
var Qt = "[object Null]", Wt = "[object Undefined]", we = V ? V.toStringTag : void 0;
function Yt(e) {
  return e == null ? e === void 0 ? Wt : Qt : we && we in Object(e) ? zt(e) : qt(e);
}
function Zt(e) {
  return e != null && typeof e == "object";
}
var Kt = "[object Symbol]";
function Jt(e) {
  return typeof e == "symbol" || Zt(e) && Yt(e) == Kt;
}
var Xt = /\s/;
function en(e) {
  for (var n = e.length; n-- && Xt.test(e.charAt(n)); )
    ;
  return n;
}
var tn = /^\s+/;
function nn(e) {
  return e && e.slice(0, en(e) + 1).replace(tn, "");
}
function ue(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var Me = NaN, rn = /^[-+]0x[0-9a-f]+$/i, an = /^0b[01]+$/i, on = /^0o[0-7]+$/i, sn = parseInt;
function _e(e) {
  if (typeof e == "number")
    return e;
  if (Jt(e))
    return Me;
  if (ue(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ue(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = nn(e);
  var t = an.test(e);
  return t || on.test(e) ? sn(e.slice(2), t ? 2 : 8) : rn.test(e) ? Me : +e;
}
var ae = function() {
  return ze.Date.now();
}, cn = "Expected a function", un = Math.max, ln = Math.min;
function dn(e, n, t) {
  var r, o, c, a, s, i, u = 0, l = !1, d = !1, S = !0;
  if (typeof e != "function")
    throw new TypeError(cn);
  n = _e(n) || 0, ue(t) && (l = !!t.leading, d = "maxWait" in t, c = d ? un(_e(t.maxWait) || 0, n) : c, S = "trailing" in t ? !!t.trailing : S);
  function C(f) {
    var M = r, P = o;
    return r = o = void 0, u = f, a = e.apply(P, M), a;
  }
  function w(f) {
    return u = f, s = setTimeout(b, n), l ? C(f) : a;
  }
  function E(f) {
    var M = f - i, P = f - u, ge = n - M;
    return d ? ln(ge, c - P) : ge;
  }
  function v(f) {
    var M = f - i, P = f - u;
    return i === void 0 || M >= n || M < 0 || d && P >= c;
  }
  function b() {
    var f = ae();
    if (v(f))
      return R(f);
    s = setTimeout(b, E(f));
  }
  function R(f) {
    return s = void 0, S && r ? C(f) : (r = o = void 0, a);
  }
  function k() {
    s !== void 0 && clearTimeout(s), u = 0, r = i = o = s = void 0;
  }
  function O() {
    return s === void 0 ? a : R(ae());
  }
  function N() {
    var f = ae(), M = v(f);
    if (r = arguments, o = this, i = f, M) {
      if (s === void 0)
        return w(i);
      if (d)
        return clearTimeout(s), s = setTimeout(b, n), C(i);
    }
    return s === void 0 && (s = setTimeout(b, n)), a;
  }
  return N.cancel = k, N.flush = O, N;
}
let j;
const fn = () => j = new De(window), Te = (e, n = 300) => {
  const t = dn(e, n);
  B(() => {
    y.addResizeEventListener(t);
  }), Le(() => {
    y.removeResizeEventListener(t);
  });
}, y = {
  /**
   * Gets the current breakpoint.
   * @returns {string} - Current breakpoint.
   */
  getCurrentBreakpoint() {
    return j?.getCurrentMediaQuery().toLowerCase() || "mq1";
  },
  /**
   * Adds a resize event listener.
   * @param {Function} callback - Callback function for resize events.
   */
  addResizeEventListener(e) {
    window.addEventListener("wbresize", e), j.observe(!0);
  },
  /**
   * Removes a resize event listener.
   * @param {Function} callback - Callback function to remove.
   */
  removeResizeEventListener(e) {
    window.removeEventListener("wbresize", e), j.disconnect();
  },
  /**
   * Checks if the viewport is mobile.
   * @returns {boolean} - True if mobile, false otherwise.
   */
  isMobile() {
    return ["mq1", "mq2", "mq3"].includes(y.getCurrentBreakpoint());
  },
  /**
   * Checks if the viewport is tablet.
   * @returns {boolean} - True if tablet, false otherwise.
   */
  isTablet() {
    return ["mq1", "mq2", "mq3", "mq4"].includes(y.getCurrentBreakpoint());
  },
  /**
   * Checks if the viewport is desktop.
   * @returns {boolean} - True if desktop, false otherwise.
   */
  isDesktop() {
    return ["mq5", "mq6"].includes(y.getCurrentBreakpoint());
  }
}, Gn = () => {
  const e = p(y.getCurrentBreakpoint()), n = p(y.isMobile()), t = p(y.isTablet()), r = p(y.isDesktop());
  return B(async () => {
    fn();
  }), Te(() => {
    t.value = y.isTablet(), n.value = y.isMobile(), r.value = y.isDesktop(), e.value = y.getCurrentBreakpoint();
  }), {
    breakpoint: e,
    isTablet: t,
    isMobile: n,
    isDesktop: r,
    onWindowResize: Te
  };
}, oe = {
  MERCEDES_BENZ: {
    LEFT: ["A_CLASS", "B_CLASS", "CLA_CLASS", "GLA_CLASS", "GLB_CLASS", "EQA_CLASS", "EQB_CLASS", "EQT_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "CLE_CLASS", "V_CLASS", "EQV_CLASS"],
    // temp solution: Removing EQE_CLASS, long term adjustments in inflate
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS"]
  },
  MERCEDES_AMG: {
    LEFT: ["A_CLASS", "CLA_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "EQE_CLASS"],
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS", "SL_CLASS", "GT_CLASS"]
  },
  MERCEDES_MAYBACH: {
    LEFT: ["GLS_CLASS"],
    CENTER: ["S_CLASS"],
    RIGHT: ["EQS_CLASS"]
  },
  get "Mercedes-Benz"() {
    return oe.MERCEDES_BENZ;
  },
  get "Mercedes-AMG"() {
    return oe.MERCEDES_AMG;
  },
  get "Mercedes-Maybach"() {
    return oe.MERCEDES_MAYBACH;
  }
}, xn = [
  "TR",
  "TH",
  "KR",
  "AU",
  "JP",
  "SG",
  "MY",
  "ZA",
  // 'ZS' in the fincalc list
  "NZ",
  "IN",
  "MX",
  "TW",
  "VN",
  "BR",
  "EG"
], jn = {
  LEFT: ["SPRINTER"],
  CENTER: ["VITO", "CITAN"],
  RIGHT: ["eCITAN", "eSPRINTER", "eVITO"]
};
function Hn(e) {
  return Object.keys(e).filter((n) => e[n]).join(",");
}
function Vn(e) {
  return Array.isArray(e) ? e.join(",") : "";
}
const zn = (e, n) => e.map((t, r) => pn(t, r, n)), pn = (e, n, t) => ({
  id: void 0,
  name: "not set",
  creative: e.split("/").pop(),
  position: `banner_${t}.${n}`
}), Un = (e, n) => {
  e.ctrlKey || e.metaKey ? window.open(n, "_blank") : window.location.assign(n);
}, Fn = (e) => ["B2B", "B2C"].includes(e);
function* qn(...e) {
  const n = e.map((t) => t[Symbol.iterator]());
  for (; ; ) {
    const t = n.map((r) => r.next());
    if (t.some(({ done: r }) => r)) break;
    yield t.map(({ value: r }) => r);
  }
}
export {
  Bn as BannerClickEvent,
  Gt as BannerType,
  Mn as COMPONENT_ID_SYMBOL,
  Mt as ComponentCategory,
  Pn as CtaClickEvent,
  wn as DARK_MODE_SUBBRANDS,
  _n as DEFAULT_BRAND,
  Ae as ImpressionEvent,
  W as ONE_TEASER,
  xn as OVERSEAS_MARKETS,
  J as PHRASE_COMPARE,
  Z as PHRASE_DCP,
  K as PHRASE_ONE_TEASER,
  _t as Severity,
  Cn as VEHICLE_TILE,
  Se as aemLoaded,
  Vn as arrayToJoinedString,
  oe as brandToModelMap,
  mt as buildConfigServiceUrl,
  pn as convertBannerItemToTrackingItem,
  zn as convertBannerItemsToTrackingItems,
  lt as convertBrandToOurs,
  se as country,
  be as environment,
  Fn as isContextType,
  ce as language,
  yt as locale,
  Tt as logError,
  Ln as market,
  wt as marketId,
  vt as mbtiDiscoAirConnectionName,
  Hn as objectToJoinedString,
  dt as parseEnvironment,
  jn as positionDefinesModel,
  ye as raise,
  Un as urlLinkout,
  kn as useAemEnvironmentConnection,
  On as useAppearance,
  $n as useBannerTracking,
  yn as useBrand,
  hn as useConfigService,
  An as useDummyConfig,
  Dn as useErrorCapturer,
  Rn as useI18n,
  Nn as useMediaQuery,
  In as useSubscribeToLoadEventInShadowRoot,
  Yn as useUuid,
  Tn as useVehicleTileData,
  Gn as useViewport,
  qn as zip
};
//# sourceMappingURL=index.js.map
